import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const ThemeCtx = createContext(null);
const STORAGE_KEY = "numa_theme";
const MODES = [ "light", "dark", "system"];

function systemPrefersDark() {
  return window.matchMedia?.("(prefers-color-scheme: dark)").matches ?? false;
}

function applyMode(mode) {
  const dark = mode === "dark" || (mode === "system" && systemPrefersDark());
  document.documentElement.classList.toggle("dark", dark);
}

export function ThemeProvider({ children }) {
  const [mode, setMode] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      // Di partenza bianco, non «come il sistema»: NUMA si apre come si apre un
      // foglio, e lo schermo scuro è una scelta che si fa, non una che si
      // subisce perché il portatile è impostato così.
      return MODES.includes(stored) ? stored : "light";
    } catch {
      return "light";
    }
  });

  useEffect(() => {
    applyMode(mode);
    try {
      localStorage.setItem(STORAGE_KEY, mode);
    } catch {
      /* ignore */
    }
    if (mode !== "system") return undefined;
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const onChange = () => applyMode("system");
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, [mode]);

  const value = useMemo(
    () => ({ mode, setMode, cycle: () => setMode((m) => MODES[(MODES.indexOf(m) + 1) % MODES.length]) }),
    [mode]
  );
  return <ThemeCtx.Provider value={value}>{children}</ThemeCtx.Provider>;
}

export const useTheme = () => useContext(ThemeCtx);
